export default __webpack_public_path__ + "static/media/icon-voirPlus.fe468793.svg";